const BUSINESS_TIME_ZONE = 'Asia/Karachi';
const PAKISTAN_OFFSET_MS = 5 * 60 * 60 * 1000;

export function businessTodayParam(date = new Date()): string {
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: BUSINESS_TIME_ZONE,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  }).formatToParts(date);

  const year = parts.find((part) => part.type === 'year')?.value;
  const month = parts.find((part) => part.type === 'month')?.value;
  const day = parts.find((part) => part.type === 'day')?.value;

  if (!year || !month || !day) {
    return new Date(date.getTime() + PAKISTAN_OFFSET_MS).toISOString().slice(0, 10);
  }
  return `${year}-${month}-${day}`;
}
